var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M288 144v16h112v272H112V160h112v-16H96v304h320V144z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M193.1 252.3l-11.6 11.6 74.5 74.5 74.5-74.5-11.6-11.6-54.7 54.7V64h-16.4v243z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }